t = require('app/scripts/views/internal/teacup-with-helpers')('org_boards_for_member')

module.exports = ->
  t.ul '.pop-over-list', ->
    t.mustacheBlock 'boards', ->
      t.li ->
        t.a { href: t.mustacheVar('url') }, ->
          t.text t.mustacheVar('name')
          t.text ' '
          t.span '.quiet', ->
            t.format 'membertype', { memberType: t.mustacheVar('memberType') }
